import clsx from 'clsx'
import React, { FC, useContext, useEffect, useState } from 'react'

import { Button } from '@Components/Button'
import { Loading } from '@Components/Modal/Loading'
import { AdyenContext2 } from '@Domains/Checkout/Providers/AdyenContextProvider'
import { CheckoutModalContext } from '@Domains/Checkout/Providers/CheckoutModalProvider'
import { buildAdyenComponent } from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutPaymentStep/Components/ProviderComponents/Adyen/Hooks/useAdyen'
import {
  useAdyenCheckoutResponse,
} from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutPaymentStep/Components/ProviderComponents/Adyen/Hooks/useAdyenCheckoutResponse'
import { CheckoutPaymentComponentProps } from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutPaymentStep/Hooks/usePaymentComponentFactory'
import { MetadataContext } from '@Globals/Metadata'
import { useTranslation } from '@Globals/Translations'

import styles from './AdyenPresentToShopper.module.scss'

export const AdyenPresentToShopperButton: FC<CheckoutPaymentComponentProps> = ({
  option,
  submitPayment,
}) => {
  const { t } = useTranslation()
  const {
    adyenConfig,
    adyenInstance,
  } = useContext(AdyenContext2)
  const {
    handleAdyenResponse,
    submitAdyenAdditionalDetails,
  } = useAdyenCheckoutResponse()
  const [adyenComponent, setAdyenComponent] = useState(null)

  useEffect(() => {
    if (adyenComponent) {
      return
    }
    const component = buildAdyenComponent(adyenInstance, option.type, undefined, adyenConfig, {
      onSubmit: undefined,
      onAdditionalDetails: (state) => {
        submitAdyenAdditionalDetails(state.data)
      },
    })
    setAdyenComponent(component)
  }, [adyenComponent, adyenConfig, adyenInstance, option.type, submitAdyenAdditionalDetails])

  return (
    <div key={option.id} className={styles.payButtonWrapper}>
      <Button
        className={clsx(styles.payButton)}
        onClick={() => {
          if (!adyenComponent) {
            return
          }
          submitPayment(
            (adyenComponent as any)?.data,
            response => handleAdyenResponse(adyenInstance, response),
          )
        }}
        type="button"
      >
        {t('checkout:COF_GO_TO_SECURE_PAYMENT')}
      </Button>
    </div>
  )
}
export const AdyenPresentToShopperContent: FC<({ result })> = ({ result }) => {
  const { t } = useTranslation()
  const [firstRender, setFirstRender] = useState(true)
  const { storeURL } = useContext(MetadataContext)
  const [loading, setLoading] = useState(false)
  const { setModal } = useContext(CheckoutModalContext)
  const showCancelButton = result.action.type.toUpperCase() === 'QRCODE' || result.action.type.toUpperCase() === 'AWAIT'

  useEffect(() => {
    document.dispatchEvent(new CustomEvent('AdyenPresentToShopperModalOpened', {
      detail: {
        message: 'Adyen Present To Shopper Modal Opened',
        timestamp: new Date(),
      },
    }))
  }, [firstRender])

  useEffect(() => {
    setFirstRender(false)
  }, [])
  const handleOkayClick = () => {
    setLoading(true)
    window.location.href = storeURL('checkout/onepage/success')
  }
  const handleCancelClick = () => {
    setModal(null)
  }

  return (
    <div className={clsx(styles.modalContent, showCancelButton && styles.isQrCode)}>
      {loading && <div className={styles.modalLoading}><Loading /></div>}
      <div id="adyen-payment-result-modal-container" />
      {!showCancelButton && <Button color="dark" onClick={handleOkayClick} variant="outlined">{t('common:OKAY')}</Button>}
      {showCancelButton && <Button color="dark" onClick={handleCancelClick} variant="outlined">{t('common:CLOSE')}</Button>}
    </div>
  )
}
